<ion-button class="button-back" fill="clear" [disabled]="isDisabled" (click)="onClickButton()" (keypress)="true">
  <span class="back-icon-desktop"><left-arrow-svg></left-arrow-svg></span>
  <span class="back-icon-mobile"><chevron-back-svg></chevron-back-svg></span>
  {{ text }}
</ion-button>
